import * as MUIIcon from "react-icons/md";

import {
  CircularProgress,
  IconButton,
  Tooltip,
  TooltipProps,
} from "@mui/material";

import { Icon } from "../../Icon";
import { toast } from "react-toastify";

interface ITableAction extends Partial<TooltipProps> {
  iconName?: keyof typeof MUIIcon;
  buttonTooltip: string;
  action: () => void;
  showLoading?: boolean;
}

export function ActionButton({
  iconName,
  buttonTooltip,
  action,
  showLoading = false,
  placement = "bottom",
  id,
}: ITableAction) {
  const actionWhenIsLoading = () => {
    toast.warning("در حال انجام ...");
  };
  return (
    <div className="flex items-center" id={id}>
      <Tooltip title={buttonTooltip} placement={placement}>
        <IconButton onClick={showLoading ? actionWhenIsLoading : action}>
          {showLoading ? (
            <CircularProgress size={20} style={{ color: "white" }} />
          ) : (
            <Icon
              icon={iconName}
              className="!text-neutral-15"
              fontSize="1.35rem"
            />
          )}
        </IconButton>
      </Tooltip>
    </div>
  );
}
